import { en } from "./en";
import { fr } from "./fr";
import { es } from "./es";

export const translations = {
  en,
  fr,
  es,
};

export type SupportedLanguage = keyof typeof translations;

export const supportedLanguages: SupportedLanguage[] = ["en", "fr", "es"];

export { en, fr, es };
